export default "__VITE_ASSET__AzXJpMdE__"